export default {
  balance (state) {
    return state.balance
  },
  transaction (state) {
    return state.transaction
  },
  orderSummaryTotal (state) {
    return state.orderSummary.total
  },
  balanceFetched (state) {
    return state.balanceFetched
  }
}
